import React from "react";
import styles from "./styles.module.scss";

const ProviderSpaceCardSkeleton = () => {
  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <div className={`${styles.image} ${styles.skeleton}`} />
        <div className={styles.info}>
          <div className={`${styles.category} ${styles.skeleton}`} />
          <div className={`${styles.name} ${styles.skeleton}`} />
          <div className={`${styles.capacity} ${styles.skeleton}`}></div>
        </div>
        <div className={styles.actions}>
          <div className={styles.buttons}>
            <div className={`${styles.editButton} ${styles.skeleton}`} />
            <div className={`${styles.deleteButton} ${styles.skeleton}`} />
          </div>
          <div className={`${styles.statusHolder} ${styles.skeleton}`}></div>
        </div>
      </div>
    </div>
  );
};

export default ProviderSpaceCardSkeleton;
